module.exports = __webpack_public_path__ + "img/edge_hebergements_location_meublee.1cd41b33.svg";